import {
  RESET_STAFF_DETAIL,
  STAFF_ADD_FAILURE,
  STAFF_ADD_REQUEST,
  STAFF_ADD_SUCCESS,
  STAFF_DELETE_FAILURE,
  STAFF_DELETE_REQUEST,
  STAFF_DELETE_SUCCESS,
  STAFF_FETCH_ALL_FAILURE,
  STAFF_FETCH_ALL_REQUEST,
  STAFF_FETCH_ALL_SUCCESS,
  STAFF_UPDATE_FAILURE,
  STAFF_UPDATE_REQUEST,
  STAFF_UPDATE_SUCCESS,
  STAFF_VIEW_ALL_FAILURE,
  STAFF_VIEW_ALL_REQUEST,
  STAFF_VIEW_ALL_SUCCESS,
  STAFF_VIEW_FAILURE,
  STAFF_VIEW_REQUEST,
  STAFF_VIEW_SUCCESS,
} from './StaffType';

const initialState = {
  StaffsDetails: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    success: null,
  },
  Staff: {
    data: [],
    loading: false,
    error: null,
    success: null,
    updateSuccess: false,
    deleteLoading: false,
    updateLoading: false,
  },
};
const staffReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case STAFF_VIEW_REQUEST:
    case STAFF_ADD_REQUEST:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          loading: true,
          error: null,
          deleteLoading: false,
          updateLoading: false,
        },
      };

    case STAFF_VIEW_ALL_REQUEST:
      return {
        ...state,
        StaffsDetails: {
          ...state.StaffsDetails,
          loading: true,
          error: null,
          success: null,
        },
      };
    case STAFF_FETCH_ALL_REQUEST:
      return {
        ...state,
        StaffsDetails: {
          ...state.StaffsDetails,
          loading: true,
          error: null,
          success: null,
        },
      };
    case STAFF_UPDATE_REQUEST:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          loading: true,
          error: null,
          updateSuccess: false,
          deleteLoading: false,
          updateLoading: true,
        },
      };
    case STAFF_DELETE_REQUEST:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          loading: true,
          error: null,
          deleteLoading: true,
          updateLoading: false,
        },
      };
    case STAFF_VIEW_SUCCESS:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: payload,
          loading: false,
          error: null,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_ADD_SUCCESS:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          loading: false,
          success: payload.message,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_UPDATE_SUCCESS:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          message: null,
          success: false,
          updateSuccess: payload.message,
          loading: false,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_VIEW_ALL_SUCCESS:
      return {
        ...state,
        StaffsDetails: {
          // Update the StaffsDetails object
          ...state.StaffsDetails, // Spread existing StaffsDetails
          data: action.payload.data.length > 0 ? action.payload.data : [], // Set data, or empty if no records found
          totalRecords: action.payload.totalRecords || 0, // Set totalRecords
          totalPages: action.payload.totalPages || 0, // Set totalPages
          currentPage: action.payload.currentPage || 1, // Set currentPage
          loading: false,
          success: payload?.message,
        },
      };
    case STAFF_FETCH_ALL_SUCCESS:
      return {
        ...state,
        StaffsDetails: {
          // Update the StaffsDetails object
          ...state.StaffsDetails, // Spread existing StaffsDetails
          data: action.payload.data.length > 0 ? action.payload.data : [], // Set data, or empty if no records found
          totalRecords: action.payload.totalRecords || 0, // Set totalRecords
          totalPages: action.payload.totalPages || 0, // Set totalPages
          currentPage: action.payload.currentPage || 1, // Set currentPage
          loading: false,
          success: payload?.message,
        },
      };
    case STAFF_DELETE_SUCCESS:
      return {
        ...state,

        Staff: {
          ...state.Staff,
          data: [],
          loading: false,
          success: payload?.data?.message,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_VIEW_FAILURE:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          error: payload,
          loading: false,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_VIEW_ALL_FAILURE:
      return {
        ...state,
        StaffsDetails: {
          ...state.StaffsDetails,
          data: [],
          error: payload,
          loading: false,
        },
      };
    case STAFF_FETCH_ALL_FAILURE:
      return {
        ...state,
        StaffsDetails: {
          ...state.StaffsDetails,
          data: [],
          error: payload,
          loading: false,
        },
      };

    case STAFF_UPDATE_FAILURE:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          error: payload,
          loading: false,
          success: false,
          updateSuccess: false,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case STAFF_ADD_FAILURE:
    case STAFF_DELETE_FAILURE:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          error: payload,
          loading: false,
          deleteLoading: false,
          updateLoading: false,
        },
      };
    case RESET_STAFF_DETAIL:
      return {
        ...state,
        Staff: {
          ...state.Staff,
          data: [],
          loading: false,
          error: null,
          success: false,
          updateSuccess: false,
          deleteLoading: false,
          updateLoading: false,
        },
        StaffsDetails: {
          ...state.StaffsDetails,
          data: [],
          totalRecords: 0,
          totalPages: 0,
          currentPage: 1,
          loading: false,
          error: null,
          success: null,
        },
      };

    default:
      return state;
  }
};

export default staffReducer;
